"use client"

import { IconArrowLeft, IconError404, IconLogout2 } from "@tabler/icons-react"
import Link from "next/link"
import { usePathname, useRouter } from "next/navigation"

import Button from "components/Button/Button"
import styles from "./not-found.module.scss"
import "styles/common.scss"
import "styles/index.scss"

export default function Custom404() {
  const pathname = usePathname()
  const router = useRouter()
  const showButton = pathname.includes("external/swayam/")

  const handleGoBack = () => {
    if (window.history.length > 2) {
      router.back()
    } else {
      router.push("/external/swayam")
    }
  }

  return (
    <div className={styles.root}>
      <IconError404 size={150} />
      <div className={styles.content}>
        <span className={styles.message}>Uh-oh! Something went off course.</span>
        <span className={styles.messageText}>The page you&apos;re looking for doesn&apos;t seem to exist.</span>
      </div>
      {showButton && (
        <div className={styles.buttonContainer}>
          <Button className={styles.button} onClick={handleGoBack}>
            <IconArrowLeft />
            Go to the last visited page
          </Button>
          <Link href="/external/swayam">
            <Button className={styles.button}>
              <IconLogout2 />
              Go to Homepage
            </Button>
          </Link>
        </div>
      )}
    </div>
  )
}
